import React from "react";
import ProductPageRedesign from "../redesign/ProductPageRedesign";
import { ComplexGenericsItems } from "./ComplexGenericsItems";

const ComplexGenerics = () => {
  return (
    <ProductPageRedesign
      title="Complex Generics"
      description="We identify unmet medical needs in various therapeutic areas and develop clinically complex products with effective, safe, and affordable processes. Our Direct Compression approach and in-house technology allow us to convert OROS formulations to Matrix-based formulations with proven stability and bioequivalency, reducing the overall cost of the formulation and helping our clients increase profitability."
      items={ComplexGenericsItems}
      bannerImage="https://images.unsplash.com/photo-1587854692152-cbe660dbbab9?q=80&w=1920&auto=format&fit=crop"
    />
  );
};

export default ComplexGenerics;
